/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-10-17 14:03:51
 * @LastEditors: linxi
 * @LastEditTime: 2025-02-26 11:03:24
 */
import {
  CloseCircleOutlined,
  CloseOutlined,
  FileImageOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, notification, Spin, Image, Upload, Form, Radio, Col } from 'antd'
import React, { ReactElement, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import styles from '../../putstorelist/Putstorelist.module.css'
import {selectTenantCityCode, selectTenantId} from "../../../app/applicationSlice";
import { getWXQMCode, getWXQMCodeFn } from '../../../layouts/DefaultLayout'
import { getCloseTreatmentBeautySignQRCodeAsync, getTreatmentBeautySignImgAsync } from './beautyClinicSlice'
import { getKQBLQMCode, getSavePatientTemplateSignAsync } from '../oralCases/oralCasesSlice'

let timer: any = null

interface uploadSignatureModalProps {
  signImgName?: any
  templateData?: any
  patientId?: string
  treatmentId?: string
  flag?: string
  uploadModalVisible: boolean
  id?: string
  maxCount?: number
  onCancel: () => void
  onSubmit: (file: any) => void
}

export const UploadSignatureModal = ({
  signImgName,
  templateData,
  patientId,
  treatmentId,
  flag,
  uploadModalVisible,
  maxCount = 1,
  onCancel,
  onSubmit,
}: uploadSignatureModalProps): ReactElement => {

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [imgSrc, setImgSrc] = useState('') //预览图片路径

  const [visible, setVisible] = useState(false)

  const [uploadLoading, setUploadLoading] = useState(false)

  const [confirmLoading, setConfirmLoading] = useState(false) //确认按钮loading

  const [WXuploadLoading, setWXUploadLoading] = useState(false)

  const [clinicWXCode, setIsClinicWXCode] = useState('') //微信上传附件二维码

  const cityCode = useSelector(selectTenantCityCode)
  const tenantId = useSelector(selectTenantId)

  const [imgList, setImgList] = useState<any>([]) //图片预览

  const [timeFlag, setTimeFlag] = useState(false) //定时器是否清楚

  const [key, setKey] = useState('') //微信上传附件二维码key

  const [flagText, setFlagText] = useState('') //判断是否是新上传的签名
  // flagText如果是老的key 说明患者之前签过名且没有重新上传 ,只是切换,
  // flagText如果是新的key 说明患者没有签过名,
  useEffect(() => {
    console.log(flagText, signImgName + '老的', key + '新的', "水水水水水水水水水水水")
  }, [flagText, key, uploadModalVisible])

  const getWXCode = () => {
    //获取图片路径
    setWXUploadLoading(true)
    // 知情同意书获取二维码
    if (flag == 'zqtysPrint') {
      // const signatureSelection = templateData?.templateId == '40' || templateData?.templateId == '41' || templateData?.templateId == '42' ? 'jhr' : 'hz'
      getUrl()
    } else {
      // 高级病历获取二维码
      dispatch(getWXQMCode())
        .then(unwrapResult)
        .then((res: any) => {
          setIsClinicWXCode(res?.url)
          setKey(res?.key)
        })
        .finally(() => setWXUploadLoading(false))
    }
  }

  // 知情同意书获取二维码
  const getUrl = (signatureSelection?: any) => {
    const pageParam = 'kqzq' + '-' + patientId + '-' + treatmentId + '-' + templateData?.templateId + '-'
    dispatch(getKQBLQMCode({ pageParam: pageParam }))
      .then(unwrapResult)
      .then((res: any) => {
        setIsClinicWXCode(res?.url)
        setKey(res?.key)
      })
      .finally(() => setWXUploadLoading(false))
  }

  useEffect(() => {
    if (uploadModalVisible) {
      setImgList([])
      getWXCode()
    } else {
      setImgSrc('')
      setImgList([])
      setTimeFlag(false)
      setIsClinicWXCode('')
      setKey('')
    }
  }, [uploadModalVisible])

  useEffect(() => {
    // 知情同意书回填
    if (uploadModalVisible) {
      if (flag == 'zqtysPrint') {
        if (!signImgName) {
          form.setFieldsValue({ signatureSelection: templateData?.templateName == '儿童牙病治疗知情同意书' || templateData?.templateName == '儿童束缚治疗知情同意书' || templateData?.templateName == 'MRC肌功能治疗知情同意书' ? 'jhr' : 'hz' })
        }
      }
    } else {
      form.resetFields()
    }
  }, [uploadModalVisible])


  useEffect(() => {
    // 有图片的进来先调一下
    if (uploadModalVisible) {
      if (flag == 'zqtysPrint') {
        // 有上传过图片的默认回填
        if (signImgName) {
          const signImgNameParam = signImgName.split('~')[1]
          dispatch(getTreatmentBeautySignImgAsync(signImgName?.split('~')[0]) )
            .then(unwrapResult)
            .then((res: any) => {
              // 有图片进来会调一下查询文件的接口 用老的key 获取图片 这个时候是有图片的 
              if (JSON.stringify(res) != '{}') {
                setImgSrc(JSON.stringify(res) != '{}' ? res : '')
                setImgList(JSON.stringify(res) != '{}' ? [res] : [])
              }
              setFlagText('oldKey')
            })
          form.setFieldsValue({ signatureSelection: signImgNameParam })
        }else{
          setFlagText('newKey')
        }
      }
    }
  }, [signImgName, uploadModalVisible])

  // 轮询查看是否上传过图片
  useEffect(() => {
    if (uploadModalVisible) {
      timer = setInterval(() => {
        if (key) {
          getUploadFileListFn()
        }
      }, 2000)
      if (timeFlag) {
        clearInterval(timer)
      }
    }
    return () => {
      timer && clearInterval(timer)
    }
  }, [uploadModalVisible, timeFlag, key])

  //获取已上传文件列表
  const getUploadFileListFn = () => {
    dispatch(getTreatmentBeautySignImgAsync(key))
      .then(unwrapResult)
      .then((res: any) => {
        if (JSON.stringify(res) != '{}') {
          setImgSrc(JSON.stringify(res) != '{}' ? res : '')
          setImgList(JSON.stringify(res) != '{}' ? [res] : [])
          timer && clearInterval(timer)
          setFlagText('newKey')
        } else {
          if (signImgName) {
            setFlagText('oldKey')
          } else {
            setFlagText('newKey')
          }
        }
      })
  }

  //上传文件保存
  const submit = async (file: File) => {
    onSubmit && onSubmit(file)
  }

  const closeUrl = () => {
    dispatch(getCloseTreatmentBeautySignQRCodeAsync())
      .then(unwrapResult)
      .then((v) => {
        return
      })
  }
  return (
    <Modal
      width={500}
      maskClosable={false}
      title='扫码签名'
      confirmLoading={confirmLoading}
      visible={uploadModalVisible}
      onCancel={() => {
        onCancel && onCancel()
        form.resetFields()
        closeUrl()
      }}
      onOk={async () => {
        if (imgList?.length != 0) {
          if (imgList[0]) {
            // 知情同意书保存签名
            if (flag == 'zqtysPrint') {
              setConfirmLoading(true)
              const signatureSelection = form.getFieldValue('signatureSelection')
              const pageParam = (flagText == 'oldKey' ? signImgName.split('~')[0] : key) + '~' + signatureSelection
              dispatch(getSavePatientTemplateSignAsync({ key: pageParam }))
                .then(unwrapResult)
                .then(() => {
                  submit(imgList[0])
                })
                .finally(() => setConfirmLoading(false))
            } else {
              // 高级病历直接回填到病历
              submit(imgList[0])
            }
          }
        } else {
          setUploadLoading(false)
          notification.warn({
            message: `请先上传图片`,
          })
        }
      }}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {flag == 'zqtysPrint' && (
        <Form form={form}>
          <Col span={24}>
            <Form.Item
              name='signatureSelection'
              label='签名选择'
              rules={[{ required: true }]}
            >
              <Radio.Group>
                {templateData?.templateId != '40' && templateData?.templateId != '41' && templateData?.templateId != '42' ? <Radio value='hz'>患者签名</Radio> : <></>}
                <Radio value='jhr'>受委托人/法定监护人签名</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Form>
      )}
      <div>
        <div>
          <div style={{ flex: 1.1 }}>
            {/* <p>方法一：</p> */}
            <p>使用微信扫描二维码进行签名</p>
            <Spin spinning={WXuploadLoading}>
              {clinicWXCode != '' ? (
                <Image
                  width={200}
                  src={clinicWXCode}
                  onError={() => setIsClinicWXCode('')}
                />
              ) : (
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    getWXCode()
                  }}
                >
                  图片加载失败点击刷新页面
                </p>
              )}
            </Spin>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: 20 }}>
          <p style={{ width: 30 }}>签名</p>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {clinicWXCode && imgList?.length != 0 && imgList?.map(
              (v: any, index: number) => {
                return (
                  <>
                    <div key={index} className={styles.imgWrap}>
                      <img
                        className={styles.imgSignature}
                        onClick={() => {
                          setVisible(true)
                          setImgSrc(v)
                        }}
                        src={v}
                      />
                    </div>
                  </>
                )
              }
            )}
          </div>
        </div>
        <Image
          style={{ display: 'none' }}
          src={imgSrc}
          preview={{
            visible,
            onVisibleChange: (value) => {
              setVisible(value)
            },
          }}
        />
      </div>
    </Modal >
  )
}
